import { createMqFunc, } from '@haaretz/htz-css-tools';
import bps from '../consts/bps';

const mq = createMqFunc(bps);
export default mq;
